<evo-dialog>

  @for (message of sanitizedInfoscreens; track message; let i = $index) {
    <div>
      @if (currentOpenedMessagesIndex === i) {
        <evo-icon-button [iconName]="iconNames.Cross" [iconSize]="iconSizes.normal" (click)="close()" class="float-right" header></evo-icon-button>
        <div content>
          <evo-spacer [height]="50" class="isDesktop"></evo-spacer>
          <evo-spacer [height]="10" class="isTablet isMobile"></evo-spacer>
          <div [innerHTML]="message" class="nav__label paragraphM"></div>
          @if (!iFramePresent) {
            <evo-spacer [height]="100" class="isDesktop"></evo-spacer>
          }
          @if (iFramePresent) {
            <evo-spacer [height]="50" class="isDesktop"></evo-spacer>
          }
          <evo-spacer [height]="20" class="isTablet isMobile"></evo-spacer>
        </div>
        <div footer>
          <div class="flex-container">
            @if (i !== 0 && i <= infoScreens.length-1) {
              <evo-button (click)="previous()" [iconPosition]="ButtonIconPosition.Left" [icon]="iconNames.ArrowLeft" class="flex-container info-screen-button">
                Previous message
              </evo-button>
            }
            <!-- show when prev button hidden to reserve space -->
            @if (i === 0) {
              <div></div>
            }
            <evo-checkbox [control]="markAsReadControl" [label]="'Mark as read'">
            </evo-checkbox>
            @if (i < infoScreens.length-1) {
              <evo-button (click)="next()" [iconPosition]="ButtonIconPosition.Right" [icon]="iconNames.ArrowRight" class="flex-container info-screen-button">
                Next message
              </evo-button>
            }
            @if (i === infoScreens.length-1) {
              <evo-button (click)="closeOrUpdate()" [iconPosition]="ButtonIconPosition.Right" [icon]="iconNames.Check" class="flex-container info-screen-button">
                Close info screen
              </evo-button>
            }
          </div>
        </div>
      }
    </div>
  }

</evo-dialog>